export default function finalList(
  state = {
    isLoading: false,
    finalList: {
      isLoading: false,
      loaded: false,
      error: false,
      errorText: '',
      data: {},
    },
    finalListOptions: {
      isLoading: false,
      loaded: false,
      error: false,
      errorText: '',
      data: {},
    },
    collegeApplications: undefined,
    colleges: [],
  },
  action,
) {
  switch (action.type) {
    case 'SET_FINAL_LIST_BUSY':
      return {
        ...state,
        isLoading: true,
      };
    case 'SET_FINAL_LIST_NOT_BUSY':
      return {
        ...state,
        isLoading: false,
      };
    case 'ERROR_RETRIEVING_FINAL_LIST"':
      return {
        ...state,
        finalList: {
          ...state.finalList,
          isLoading: false,
          loaded: true,
          errorText: 'Error retrieving final list',
          error: true,
          data: {},
        },
      };
    case 'POPULATE_FINAL_LIST':
      return {
        ...state,
        finalList: {
          ...state.finalList,
          isLoading: false,
          loaded: true,
          errorText: '',
          error: false,
          data: action.data,
        },
      };
    case 'ERROR_RETRIEVING_FAVORITES_AND_WISHLIST':
      return {
        ...state,
        finalListOptions: {
          ...state.finalListOptions,
          isLoading: false,
          loaded: true,
          errorText: 'Error retrieving favorites and wishlist',
          error: true,
          data: {},
        },
      };
    case 'POPULATE_STUDENT_FINAL_LIST_SCHOOLS':
      return {
        ...state,
        finalListOptions: {
          ...state.finalListOptions,
          isLoading: false,
          loaded: true,
          errorText: '',
          error: false,
          data: action.data,
        },
      };
    case 'POPULATE_COLLEGE_APPLICATIONS':
      return {
        ...state,
        collegeApplications: action.collegeApplications,
      };
    case 'POPULATE_COLLEGE_LIST':
      return {
        ...state,
        colleges: action.data,
      };
    default:
      return state;
  }
}
